import React from "react";
import { NavLink } from "react-router-dom";
import "../styles/polaris-admin.css";
import CompaniesIcon from "../images/nav-icons/Team-active.svg";
import UsersIcon from "../images/nav-icons/student-directory-active.svg";
import MetricsIcon from "../images/nav-icons/Billing-active.svg";
import SalesIcon from "../images/nav-icons/Billing.svg";
import AiAssistantActiveIcon from "../images/nav-icons/Polaris-Assist-black-star.svg";
import AiAssistantInactiveIcon from "../images/nav-icons/Polaris-Assist-inactive.svg";
import KnowledgeBaseIcon from "../images/nav-icons/knowledge-base.svg";
import CourseInsightsIcon from "../images/nav-icons/Resources-active.svg";
import RailSidebarShell from "./RailSidebarShell";

const items = [
    { id: "companies", label: "Companies & Schools", iconSrc: CompaniesIcon, path: "/polaris-admin/companies" },
    { id: "users",     label: "Users",               iconSrc: UsersIcon,     path: "/polaris-admin/users" },
    { id: "metrics",   label: "Metrics",             iconSrc: MetricsIcon,   path: "/polaris-admin/metrics" },
    { id: "sales",     label: "Sales",               iconSrc: SalesIcon,     path: "/polaris-admin/sales" },
    { id: "ai-assistant",  label: "Polaris Assist",    iconSrc: AiAssistantInactiveIcon, path: "/polaris-admin/ai-assistant" },
    { id: "instant-chat", label: "Instant Chat", iconSrc: CompaniesIcon, path: "/polaris-admin/instant-chat" },
    { id: "hub", label: "Hub Content", iconSrc: CourseInsightsIcon, path: "/polaris-admin/hub" },
    { id: "reference-data", label: "Reference Data", iconSrc: KnowledgeBaseIcon, path: "/polaris-admin/reference-data" },
    { id: "feature-ideas", label: "Feature Ideas", iconSrc: CourseInsightsIcon, path: "/polaris-admin/feature-ideas" },
    { id: "support", label: "Support", iconSrc: CourseInsightsIcon, path: "/polaris-admin/support" },
    { id: "caches", label: "Cache Management", iconSrc: MetricsIcon, path: "/polaris-admin/caches" },
    { id: "knowledge-base",label: "Knowledge Base",  iconSrc: KnowledgeBaseIcon, path: "/polaris-admin/knowledge-base" },
];

export type PolarisSidebarProps = {
    profileImageUrl?: string | null;
};

export default function PolarisSidebar({ profileImageUrl = null }: PolarisSidebarProps) {
    return (
        <RailSidebarShell
            headerLogoUrl={null}
            footerAvatarUrl={profileImageUrl}
            footerAvatarAlt="Your profile"
            confirmLogout={false}
            showRaiseTicket={false}
            showGettingStarted={false}
            data-testid="polaris-rail-sidebar"
        >
            <nav className="polaris-side-nav">
                {items.map((item) => (
                    <NavLink
                        key={item.id}
                        to={item.path}
                        className={({ isActive }) =>
                            `polaris-side-link${isActive ? " is-active" : ""}`
                        }
                        data-testid={`polaris-sidebar-${item.id}`}
                    >
                        {({ isActive }) => (
                            <>
                                <span className="polaris-side-ico">
                                    <img
                                        src={
                                            item.id === "ai-assistant"
                                                ? isActive
                                                    ? AiAssistantActiveIcon
                                                    : AiAssistantInactiveIcon
                                                : item.iconSrc
                                        }
                                        alt=""
                                        aria-hidden="true"
                                        className={
                                            item.id === "ai-assistant" && isActive
                                                ? "polaris-side-img side-img--fullcolor"
                                                : "polaris-side-img"
                                        }
                                    />
                                </span>
                                <span className="polaris-side-label">{item.label}</span>
                            </>
                        )}
                    </NavLink>
                ))}
            </nav>
        </RailSidebarShell>
    );
}
